@if (store$ | async; as store) {
  <boels-vertical-aligner [innerWidth]="'wide'">
    <h1 class="h2">
      {{
        'storeFinder.storeDetails.title'
          | transloco: { displayName: store.displayName }
      }}
    </h1>
    <div class="boels-store-finder-details__container">
      <div class="boels-store-finder-details__store">
        <h5 class="boels-store-finder-details__store-name">
          {{ store.displayName }}
        </h5>
        @if (store.address) {
          <p class="boels-store-finder-details__address">
            {{ store.address.line1 }} {{ store.address.line2 }} <br />
            {{ store.formattedAddress }}
          </p>
        }

        <div class="boels-store-finder-details__block -content">
          <h5>{{ 'storeFinder.storeDetails.contactDetails' | transloco }}</h5>
          <div class="boels-store-finder-details__list">
            @if (store.address?.phone) {
              <div class="boels-store-finder-details__list-item">
                <span boelsQa="store-details-label-phone">
                  {{ 'storeFinder.storeDetails.tel' | transloco }}
                </span>
                @if (store.address?.phone) {
                  <a
                    [href]="'tel:' + store.address?.phone | phoneFilter"
                    boelsQa="store-details-value-phone"
                    >{{ store.address?.phone }}</a
                  >
                }
              </div>
            }
            @if (store.address?.fax) {
              <div class="boels-store-finder-details__list-item">
                <span boelsQa="store-details-label-fax">
                  {{ 'storeFinder.storeDetails.fax' | transloco }}
                </span>
                <a
                  [href]="'tel:' + store.address?.fax | phoneFilter"
                  boelsQa="store-details-value-fax"
                >
                  {{ store.address?.fax }}
                </a>
              </div>
            }
            @if (store.address?.email) {
              <div class="boels-store-finder-details__list-item">
                <span boelsQa="store-details-label-email">
                  {{ 'storeFinder.storeDetails.Email' | transloco }}
                </span>
                <a
                  [href]="'mailTo:' + store.address?.email"
                  boelsQa="store-details-value-email"
                >
                  {{ store.address?.email }}
                </a>
              </div>
            }
          </div>
        </div>

        @if (store.openingHours) {
          <div class="boels-store-finder-details__block -openingHours">
            <h5 boelsQa="store-details-label-opening-hours">
              {{ 'storeFinder.storeDetails.openingHours' | transloco }}
            </h5>
            <div
              class="boels-store-finder-details__list"
              boelsQa="store-details-openingHours-list"
            >
              @for (
                day of store.openingHours.weekDayOpeningList || [];
                track day
              ) {
                <div class="boels-store-finder-details__list-item">
                  <div boelsQa="store-details-label-day">{{ day.weekDay }}</div>
                  @if (day.closed) {
                    <div boelsQa="store-details-value-hours">
                      {{ 'storeFinder.storeDetails.closed' | transloco }}
                    </div>
                  } @else {
                    <div boelsQa="store-details-value-hours">
                      {{ day.openingTime?.formattedHour }} -
                      {{ day.closingTime?.formattedHour }}
                      @if (day.openingTime2 && day.closingTime2) {
                        & {{ day.openingTime2.formattedHour }} -
                        {{ day.closingTime2.formattedHour }}
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (store.specialisms?.length! > 0) {
          <div class="boels-store-finder-details__block -specialisms">
            <h5>
              {{ 'storeFinder.specialism.label' | transloco }}
              <fa-icon
                [ngbTooltip]="'storeFinder.specialism.tooltip' | transloco"
                [tooltipClass]="'ngb-boels-tooltip'"
                [autoClose]="'inside'"
                [placement]="'top auto'"
                [icon]="infoIcon"
              ></fa-icon>
            </h5>
            <p class="subtitle">
              {{ 'storeFinder.specialism.subtitle' | transloco }}
            </p>
            <div class="boels-store-finder-details__specialism-icons-container">
              @for (specialism of store.specialisms || []; track specialism) {
                <img
                  [src]="specialism.icon?.url"
                  [alt]="specialism.name"
                  [ngbTooltip]="iconTooltip"
                  [tooltipClass]="'ngb-boels-tooltip'"
                  [autoClose]="'inside'"
                  [placement]="
                    'top-left top top-right right left bottom-left bottom-right auto'
                  "
                  loading="lazy"
                />
                <ng-template #iconTooltip>
                  <div class="boels-store-finder-details__specialism-tooltip">
                    @if (specialism.name) {
                      <div
                        class="boels-store-finder-details__specialism-tooltip__title"
                      >
                        {{ specialism.name }}
                      </div>
                    }
                    @if (specialism.description) {
                      <div>
                        {{ specialism.description }}
                      </div>
                    }
                  </div>
                </ng-template>
              }
            </div>
          </div>
        }
        <div class="boels-store-finder-details__directions">
          <a
            boelsAnchorButton
            [variant]="'primary-brand'"
            [href]="
              'https://www.google.com/maps/dir/Current+Location/' +
              store.geoPoint.latitude +
              ',' +
              store.geoPoint.longitude
            "
            target="_blank"
            rel="noopener"
            [attr.data-dm]="
              {
                data_type: 'cta',
                item_name: 'branch-list btn-route',
              } | json
            "
          >
            {{ 'storeFinder.storeDetails.getDirections' | transloco }}
          </a>
        </div>
      </div>
      @if (!$isMobile()) {
        <div class="boels-store-finder-details__map">
          <boels-google-maps
            class=""
            [active]="store"
            [pointOfServices]="[store]"
            [zoomLevel]="13"
            [fitBounds]="false"
          ></boels-google-maps>
        </div>
      }
    </div>

    @if (store.seoStoreContent) {
      <div class="boels-store-finder-details__seo-content">
        <div
          class="content"
          [innerHTML]="store.seoStoreContent | prepareHtml"
        ></div>
        <div class="side-content">
          @if (store.storeImages?.length! > 0) {
            <boels-media
              [container]="store.storeImages?.[0]"
              [alt]="store.storeImages?.[0]?.altText || store.displayName"
            ></boels-media>
          }
          <boels-well>
            <boels-usp [componentData]="cartUspNodes$"></boels-usp>
          </boels-well>
        </div>
      </div>
    }
  </boels-vertical-aligner>
} @else {
  <boels-spinner></boels-spinner>
}

<ng-template #loading>
  <boels-spinner></boels-spinner>
</ng-template>
